/* eslint-disable no-restricted-imports */
import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';
import type Progress from 'pages/open-course/common/models/progress';

class WiseFlowState {
  declare itemMetadata: ItemMetadata;

  // @ts-expect-error ts-migrate(2749) FIXME: 'Progress' refers to a value, but is being used as... Remove this comment to see the full error message
  declare itemProgress: Progress;

  // @ts-expect-error ts-migrate(2749) FIXME: 'Progress' refers to a value, but is being used as... Remove this comment to see the full error message
  constructor(itemMetadata: ItemMetadata, itemProgress: Progress) {
    this.itemMetadata = itemMetadata;
    this.itemProgress = itemProgress;
  }

  isCompleted(): boolean {
    return this.itemProgress.isComplete();
  }

  isSubmitted(): boolean {
    const submittedAt = this.itemProgress.getDefinition('submittedAt');
    return this.itemProgress.hasStarted() && submittedAt;
  }

  isStarted(): boolean {
    const submittedAt = this.itemProgress.getDefinition('submittedAt');
    return this.itemProgress.hasStarted() && !submittedAt;
  }
}

export default WiseFlowState;
